import React from 'react';
import { GzipCompression } from '../components/gzip-compression/GzipCompression';

export const GzipCompressionPage: React.FC = () => {
  return (
    <div className="page-container">
      <GzipCompression />
    </div>
  );
};